export default "__VITE_ASSET__B3uHqn8S__"